import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import Navbar from "../../Navbar";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { UrlApi } from "../../../services/apirest";
import moment from "moment";
import { getData } from "../../../services/library";
import NotAllow from "../notAllow/NotAllow";
import { enviarsms } from "../../../services/services";
import ModalEnviarSms from "./ModalEnviarSms";
import { logEventos } from "../../../services/services";
import LockOutlineIcon from "@mui/icons-material/LockOutlined";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { useToast } from "../../../Hooks/UseToast";

const GenerarExcel = () => {
  const [openModalParaMandarSms, setOpenModalParaMandarSms] = useState(false);
  const [estadoTabla, setEstadoTabla] = useState(null);

  const { Toast, showToast } = useToast();

  const [form, setForm] = useState({
    idSucursal: Number(localStorage.getItem("sucursal")) ?? "",
    fechaInicio: "",
    fechaFin: "",
  });

  const [users, setUsers] = useState([]);

  const rrhhAdmin = localStorage.getItem("adminrrhh");

  useEffect(() => {
    getData("/viandas/menu/days", (data) => {
      const fechas = data.map((dia) => Object.values(dia)[0]); // cada uno tiene solo un valor

      setForm((prev) => ({
        ...prev,
        fechaInicio:
          prev.fechaInicio ||
          moment(fechas[0], "DD/MM/YYYY").format("YYYY-MM-DD"),
        fechaFin:
          prev.fechaFin || moment(fechas[4], "DD/MM/YYYY").format("YYYY-MM-DD"),
      }));
    });

    getData("/viandas/tabla/estado", setEstadoTabla);
    getData("/viandas/menu/usuariosSMS", setUsers);
  }, []);

  const handleChangeStatusTable = async () => {
    const newState = estadoTabla.bloqueado === 1 ? 0 : 1;
    const response = await fetch(
      `${UrlApi}/viandas/tabla/bloquear/${newState}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
    const data = await response.json();
    if (response.ok) {
      setEstadoTabla({ bloqueado: newState });

      let word = newState === 1 ? "Bloqueo" : "Desbloqueo";
      if (newState === 1) mandarSMS(users);
      logEventos(
        `${localStorage.getItem("user")} ${word} la tabla`,
        "Viandas",
        "Generar CSV de viandas",
        localStorage.getItem("user")
      );
      showToast(`La tabla se ${word} correctamente`, "success");
    } else {
      console.error(data);
      showToast("Error al bloquear/desbloquear la tabla", "error");
      return;
    }
  };
  const mandarSMS = (listaDeUsuarios) => {
    const usuarios = listaDeUsuarios.data;

    usuarios.forEach((user) => {
      const { celular, nombrepila, apellido } = user;
      const message = `Hola ${nombrepila} ${apellido}, te informamos que el horario de selección de viandas ya cerró.`;
      enviarsms(celular, message);
    });
  };

  const abrirModal = () => {
    setOpenModalParaMandarSms(true);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    //validaciones antes del try
    if (form.fechaFin < form.fechaInicio) {
      showToast(
        "La fecha de fin no puede ser anterior a la fecha de inicio.",
        "warning"
      );
      return;
    }

    try {
      const response = await fetch(
        `${UrlApi}/viandas/pedidos/semanal?idSucursal=${form.idSucursal}&fechaInicio=${form.fechaInicio}&fechaFin=${form.fechaFin}`
      );

      if (!response.ok) {
        const errorData = await response.json();
        showToast(errorData.message || "Error al generar el EXCEL", "error");
        return;
      }
      const empresa = form.idSucursal === 8 ? "Casa central" : "Netizar S.A.";
      const fechaHoy = moment().format("DD-MM-YYYY");
      const disposition = response.headers.get("Content-Disposition");
      const filename =
        disposition?.match(/filename="?(.+)"?/)?.[1] ||
        `Viandas_${empresa}_${fechaHoy}.xlsx`;

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("download", filename); // nombre dinámico
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
      logEventos(
        "Genero un resumen excel",
        "Viandas",
        "Generar CSV de viandas",
        localStorage.getItem("user")
      );
      abrirModal();
    } catch (error) {
      console.error("Error al descargar el EXCEL:", error);
      showToast("Error al descargar el EXCEL", "error");
    }
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Generar CSV de viandas",
      "Viandas",
      "Generar CSV de viandas",
      localStorage.getItem("user")
    );
  }, []);

  return rrhhAdmin === "1" ? (
    <>
      {openModalParaMandarSms && (
        <ModalEnviarSms
          handleSubmit={() => {
            setOpenModalParaMandarSms(false);
            mandarSMS(users);
          }}
          titulo="Enviar SMS"
          mensaje="¿Está seguro que desea enviar el SMS de cierre de la selección de viandas a los usuarios?"
          onClose={() => setOpenModalParaMandarSms(false)}
          open={openModalParaMandarSms}
        />
      )}
      <Navbar />
      <Box
        component={Paper}
        sx={{
          maxWidth: 400,
          margin: "auto",
          mt: 5,
          p: 3,
          bgcolor: "#c7e2c4",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography variant="h6" align="center" gutterBottom>
          Generar EXCEL de pedidos por sucursal
        </Typography>

        <Grid container spacing={2}>
          {/* Selector de sucursal */}
          <Grid item xs={12}>
            <FormControl required fullWidth size="small">
              <InputLabel id="sucursal-label">Sucursal</InputLabel>
              <Select
                labelId="sucursal-label"
                name="idSucursal"
                label="Sucursal"
                value={form.idSucursal}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    idSucursal: e.target.value,
                  }))
                }
              >
                <MenuItem value={8}>Casa central</MenuItem>
                <MenuItem value={1000}>Netizar S.A.</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Fecha Inicio */}
          <Grid item xs={6}>
            <TextField
              fullWidth
              type="date"
              size="small"
              name="fechaInicio"
              label="Fecha Inicio"
              InputLabelProps={{ shrink: true }}
              value={form.fechaInicio}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  fechaInicio: e.target.value,
                }))
              }
            />
          </Grid>

          {/* Fecha Fin */}
          <Grid item xs={6}>
            <TextField
              fullWidth
              type="date"
              size="small"
              name="fechaFin"
              label="Fecha Fin"
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: form.fechaInicio }}
              value={form.fechaFin}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  fechaFin: e.target.value,
                }))
              }
            />
          </Grid>
          {/* Botón de generar CSV */}
          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                bgcolor: "#6f9c3b",
                "&:hover": { bgcolor: "#4d6d29" },
              }}
              startIcon={<FileDownloadIcon />}
              onClick={onSubmit}
              disabled={!form.fechaInicio || !form.fechaFin || !form.idSucursal}
            >
              Generar EXCEL
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          sx={{ py: 2, px: 4, width: "300px", mt: 5 }}
          onClick={handleChangeStatusTable}
          startIcon={
            estadoTabla?.bloqueado === 1 ? (
              <LockOpenIcon />
            ) : (
              <LockOutlineIcon />
            )
          }
        >
          {Number(estadoTabla?.bloqueado) === 1 ? "Desbloquear " : "Bloquear "}{" "}
          tabla
        </Button>
      </Box>
      {/*  */}
      {Toast}
    </>
  ) : (
    <>
      <Navbar />
      <NotAllow />
    </>
  );
};

export default GenerarExcel;
